import { render, staticRenderFns } from "./DispositivosPantalla.vue?vue&type=template&id=e6ce116c&"
import script from "./DispositivosPantalla.vue?vue&type=script&lang=ts&"
export * from "./DispositivosPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('e6ce116c', component.options)
    } else {
      api.reload('e6ce116c', component.options)
    }
    module.hot.accept("./DispositivosPantalla.vue?vue&type=template&id=e6ce116c&", function () {
      api.rerender('e6ce116c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Dispositivos/DispositivosPantalla.vue"
export default component.exports